/**
 * @file ResizeView
 * @author Yu Zong(liuxuanzy@qq.com)
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from 'react';
import { getDefaultElementSize } from '@tencent/glue-util-boundary';
import { useElementSize } from '@tencent/glue-react-boundary';
import { useStyleTransform } from '../hooks/useStyleTransform';
import { Device } from './modules/DeviceModule';
export function ResizeView(props) {
    var id = props.id, _a = props.className, elemClassName = _a === void 0 ? '' : _a, _b = props.style, elemStyle = _b === void 0 ? {} : _b, children = props.children, onClick = props.onClick, _c = props.focusWidth, focusWidth = _c === void 0 ? true : _c, _d = props.focusHeight, focusHeight = _d === void 0 ? true : _d;
    var config = useStyleTransform(elemStyle, 'xj-h5-resize', elemClassName);
    var _e = useState(getDefaultElementSize), size = _e[0], setSize = _e[1];
    var ref = useElementSize(function () { return focusHeight && focusWidth; }, function (newSize) {
        var widthChange = focusWidth && newSize.width !== size.width;
        var heightChange = focusHeight && newSize.height !== size.height;
        if (widthChange || heightChange) {
            setSize(newSize);
        }
    })[0];
    var ratio = Device.getRatio();
    return (React.createElement("div", __assign({}, config, { id: id, ref: ref, onClick: onClick }),
        React.createElement("div", { className: "xj-h5-resize-inner", ref: ref }, typeof children === 'function'
            ? children({
                width: size.width / ratio,
                height: size.height / ratio,
            })
            : children)));
}
